import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IsupplierSharedModule} from '@i-supplier/angular-shared-module';
import {NgSelectModule} from '@ng-select/ng-select';
import {TranslateModule} from '@ngx-translate/core';
import {AlertModule} from 'ngx-bootstrap/alert';
import {PaginationModule} from 'ngx-bootstrap/pagination';
import {NgxFileDropModule} from 'ngx-file-drop';
import {SharedModule} from '../../shared/shared.module';
import {PurchaseOrderCardComponent} from './purchase-order-list/purchase-order-card/purchase-order-card.component';
import {PurchaseOrderListComponent} from './purchase-order-list/purchase-order-list.component';
import {PurchaseOrderRoutingModule} from './purchase-order-routing.module';
import {PurchaseOrderViewComponent} from './purchase-order-view/purchase-order-view.component';

@NgModule({
  declarations: [
    PurchaseOrderListComponent,
    PurchaseOrderViewComponent,
    PurchaseOrderCardComponent
  ],
  imports: [
    CommonModule,
    PurchaseOrderRoutingModule,
    SharedModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    PaginationModule,
    AlertModule,
    NgxFileDropModule,
    TranslateModule,
    IsupplierSharedModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PurchaseOrderModule {}
